export default "__VITE_ASSET__CnGvHBn4__"